import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

/* eslint-disable no-console */
import analyticsWrapper from "@xo-union/tk-analytics";
import SegmentAnalytics from "./segment/index.js";
import mixpanel from "./mixpanel/index.js";
const defaultWaitConfig = process.env.UNION_MEMBERSHIP_WAIT_FOR_ANALYTICS === 'true';

const callIfDefined = (service, f, data) => {
  if (typeof service[f] === 'function') {
    return service[f](data);
  }

  return null;
};

var _wait = /*#__PURE__*/new _WeakMap();

var _services = /*#__PURE__*/new _WeakMap();

var _maybeWaitForAllServicesTo = /*#__PURE__*/new _WeakMap();

var _getServicesList = /*#__PURE__*/new _WeakMap();

export default class MembershipAnalytics {
  constructor() {
    let {
      analytics,
      wait = defaultWaitConfig,
      services = MembershipAnalytics.defaultServices({
        analytics
      })
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classPrivateFieldInitSpec(this, _wait, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _services, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _maybeWaitForAllServicesTo, {
      writable: true,
      value: callback => {
        var _context;

        const promises = _mapInstanceProperty(_context = _classPrivateFieldGet(this, _getServicesList).call(this)).call(_context, _ref => {
          let [name, service] = _ref;
          return (callback(service) || _Promise.resolve()).catch(error => {
            console.warn(`${name} failed to report.`);
            console.error(error);
          });
        });

        if (_classPrivateFieldGet(this, _wait)) {
          return _Promise.all(promises);
        }

        return _Promise.resolve();
      }
    });

    _classPrivateFieldInitSpec(this, _getServicesList, {
      writable: true,
      value: () => _Object$entries(_classPrivateFieldGet(this, _services))
    });

    _classPrivateFieldSet(this, _wait, wait);

    _classPrivateFieldSet(this, _services, services);
  }

  reportSignUp(data) {
    return _classPrivateFieldGet(this, _maybeWaitForAllServicesTo).call(this, service => callIfDefined(service, 'reportSignUp', data));
  }

  reportLogIn(data) {
    return _classPrivateFieldGet(this, _maybeWaitForAllServicesTo).call(this, service => callIfDefined(service, 'reportLogIn', data));
  }

  reset() {
    var _context2;

    return _forEachInstanceProperty(_context2 = _classPrivateFieldGet(this, _getServicesList).call(this)).call(_context2, _ref2 => {
      let [, service] = _ref2;
      return callIfDefined(service, 'reset');
    });
  }
  /* private methods */


}

_defineProperty(MembershipAnalytics, "defaultServices", function () {
  let {
    analytics = analyticsWrapper
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    segment: new SegmentAnalytics({
      analytics
    }),
    mixpanel
  };
});